import { currentBuilderState } from '../builder.state';

export function filterMetrics(): void {
    const state = currentBuilderState();

    const keyword = (state.metricKeywords ?? '').toLowerCase().trim();

    if (!(keyword?.length > 0)) {
        state.filteredMetrics = state.metrics;
        return;
    }

    const parts = keyword.split(/\s+/);
    state.filteredMetrics = state.metrics?.filter((e) =>
        parts.every((p) => e.fullName.toLowerCase().includes(p)),
    );
}
